import { action } from 'satcheljs';

/**
 * When user tries to change a regulatory type retention label to something else,
 * this action is triggered to render a dialog indicating that the action is not allowed.
 */
export const showUpdateRestrictionOnRegulatoryPolicy = action(
    'SHOW_UPDATE_RESTRICTION_ON_REGULATORY_POLICY'
);
